<div class="error-page">
    <div class="error-content">
        <div class="error-desc">
            <page-title [title]="'errors.404.title' | i18next"></page-title>
            <p>{{ 'errors.404.text.1' | i18next }}</p>
            <p>
                {{ 'errors.404.text.2' | i18next }}<a (click)="onClickToBack()" href="#">{{ 'errors.404.text.goBack' | i18next }}</a>
                {{ 'errors.404.text.3' | i18next }}<a routerLink="/">{{ 'errors.404.text.homePage' | i18next }}</a
                >.
            </p>
        </div>
        <div class="error-actions">
            <a class="button button--primary-inverted" routerLink="/">{{ 'errors.toMainPage' | i18next }}</a>
        </div>
    </div>
    <div class="error-image">
        <img src="/assets/images/error-404.svg" />
    </div>
</div>
